import {CheckListItem} from '../../molecules/CheckListItem/CheckListItem';
import {CheckListItemProps} from '../../molecules/CheckListItem/CheckListItemProps.interface';

interface DialogCheckListItemProps
  extends Omit<CheckListItemProps, 'isTitle' | 'label'> {
  label?: string;
}

export function DialogCheckListItem(props: DialogCheckListItemProps) {
  return <CheckListItem isTitle={false} label={props.label || ''} {...props} />;
}

export const DialogCheckListItemType = (<DialogCheckListItem />).type;
